import { type IDialogManager } from '../../popup';

export abstract class PageAction<Request = any, Response extends Promise<any> = any, IScope extends angular.IScope = any> {
    protected dialogManager: IDialogManager<Response>;
    protected $injector: angular.auto.IInjectorService;

    constructor(
        $injector: angular.auto.IInjectorService,
        protected $scope: IScope
    ) {
        this.$injector = $injector;
        this.dialogManager = $injector.get<IDialogManager<Response>>('dialogManager');
    }

    public abstract run(request: Request): Response;
}
